import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function InvestorInfo() {
  const { t } = useLang();
  const c = t.investors;

  const goToContact = () => {
    window.dispatchEvent(
      new CustomEvent("agro:contact-prefill", { detail: { type: "investor" } })
    );
    document
      .querySelector("[data-testid=contact-section]")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="inversores"
      data-testid="investors-section"
      className="py-24 sm:py-32 bg-ivory"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 grid grid-cols-12 gap-y-10 gap-x-6">
        <Reveal className="col-span-12 lg:col-span-4 flex items-start gap-4">
          <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
          <span className="eyebrow">{c.eyebrow}</span>
        </Reveal>
        <Reveal as="h2" className="col-span-12 lg:col-span-8 h-section text-olive">
          {c.title}
        </Reveal>
        <Reveal className="col-span-12 lg:col-span-7 lg:col-start-5">
          <p className="text-lg text-olive-soft leading-relaxed font-serif italic">
            {c.body}
          </p>
        </Reveal>

        <Reveal className="col-span-12 lg:col-span-8 lg:col-start-5 mt-2">
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
            {c.bullets.map((b, i) => (
              <li
                key={i}
                data-testid={`investor-bullet-${i}`}
                className="flex gap-3 text-base text-olive leading-snug"
              >
                <span className="text-terracotta font-mono text-[11px] tracking-[0.2em] mt-1.5">
                  0{i + 1}
                </span>
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal className="col-span-12 lg:col-span-8 lg:col-start-5 mt-6">
          <button
            type="button"
            onClick={goToContact}
            data-testid="investors-cta"
            className="bg-olive text-ivory px-7 py-4 font-mono text-[11px] tracking-[0.28em] uppercase hover:tracking-[0.32em] transition-all duration-500"
          >
            {c.cta}
          </button>
        </Reveal>

        <Reveal className="col-span-12 lg:col-span-8 lg:col-start-5 mt-6">
          <p
            data-testid="investors-disclaimer"
            className="text-sm sm:text-base text-olive leading-relaxed font-serif italic border-t border-border pt-6"
          >
            {c.disclaimer}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
